export default "__VITE_ASSET__Djwuynev__"